import React from 'react';
import { useTranslation } from 'react-i18next';

import { UserDetails } from 'src/components/organisation/manage-otps/user-details/user-details';
import { PageHeader } from 'src/components/common/page-header';
import { useParams } from 'react-router-dom';
import { User } from 'src/graphql/generated/graphql';
import { Routes } from 'src/components/common/router/constants';
import { useUser } from 'src/hooks/query/use-user';

export const UserOTPPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const breadCrumbsProps = {
    items: [
      { label: t('manage-otps.title', 'Manage OTPs'), url: Routes.users.path },
      { label: t('profile-details.title', 'Profile details') },
    ],
  };
  const title = t('profile-details.title', 'Profile details');

  const { user: userData } = useUser({ id: id as string });

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      {userData && <UserDetails user={userData as unknown as Partial<User>} />}
    </>
  );
};

export default UserOTPPage;
